"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBindingConstraintsWithNoNameNorTags = isBindingConstraintsWithNoNameNorTags;
function isBindingConstraintsWithNoNameNorTags(constraints) {
    return constraints.name === undefined && constraints.tags.size === 0;
}
//# sourceMappingURL=isBindingConstraintsWithNoNameNorTags.js.map